import { Route, Routes } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import AppLayout from '@/components/layout/AppLayout';
import RequireAuth from '@/components/RequireAuth';
import Login from '@/pages/Login';
import Overview from '@/pages/Overview';
import Inbox from '@/pages/Inbox';
import Messages from '@/pages/Messages';
import Meetings from '@/pages/Meetings';
import Agreements from '@/pages/Agreements';
import ActionItems from '@/pages/ActionItems';
import Focus from '@/pages/Focus';
import Agents from '@/pages/Agents';
import Intel from '@/pages/Intel';
import Commissions from '@/pages/Commissions';
import Connections from '@/pages/Connections';
import Workspace from '@/pages/Workspace';
import Settings from '@/pages/Settings';
import NotFound from '@/pages/NotFound';

const App = () => (
  <TooltipProvider>
    <Toaster />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <AppLayout>
              <Routes>
                <Route path="/" element={<Overview />} />
                <Route path="/inbox" element={<Inbox />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/meetings" element={<Meetings />} />
                <Route path="/agreements" element={<Agreements />} />
                <Route path="/action-items" element={<ActionItems />} />
                <Route path="/focus" element={<Focus />} />
                <Route path="/agents" element={<Agents />} />
                <Route path="/intel" element={<Intel />} />
                <Route path="/commissions" element={<Commissions />} />
                <Route path="/connections" element={<Connections />} />
                <Route path="/testing" element={<Workspace initialTab="submit" />} />
                <Route path="/tickets" element={<Workspace initialTab="tickets" />} />
                <Route path="/board" element={<Workspace initialTab="board" />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </AppLayout>
          </RequireAuth>
        }
      />
    </Routes>
  </TooltipProvider>
);

export default App;
